

// import React, { useContext } from "react";
// import Rightcontainer from "../Components/Rightcontainer";
// import { LanguageContext } from "../Components/LanguageContext";
// import { BsArrowRightShort } from "react-icons/bs";
// // import "./SupportUI.css"; 

// const Support = () => {
//   const { language } = useContext(LanguageContext);
//   const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

//   const translations = {
//     hi: {
//       help: 'सपोर्ट सेंटर',
//       sub: 'हम आपकी सहायता के लिए 24x7 यहां हैं',
//       team: 'हमारी सहायता टीम',
//       replies: 'आमतौर पर 2 मिनट में उत्तर देता है',
//       telegram: 'Telegram Support',
//       official: 'Official Channel',
//       contact: 'Contact Us',
//       voice: 'Voice Assistance',
//       secure: 'SECURE & VERIFIED SUPPORT'
//     },
//     en: {
//       help: 'SUPPORT CENTER',
//       sub: 'We are available 24x7 to help you',
//       team: 'Our Support Team',
//       replies: 'Typically replies in 2 mins',
//       telegram: 'Telegram Support',
//       official: 'Official Channel',
//       contact: 'Contact Us',
//       voice: 'Voice Assistance',
//       secure: 'SECURE & VERIFIED SUPPORT'
//     },
//   };

//   const t = translations[language] || translations.en;

//   return (
//     <div className="support-main-wrapper leftContainer mt-5 pt-5">
//       <div className="support-inner-content">
        
//         {/* Title Section */}
//         <div className="support-title-section">
//           <h1>SUPPORT <span>CENTER</span></h1>
//           <p>{t.sub}</p>
//         </div>

//         {/* Black Status Card */}
//         <div className="team-status-card">
//           <div className="team-avatar-wrapper">
//              <img src="/images/support.jpg" alt="Support" className="team-img" />
//              <div className="online-indicator"></div>
//           </div>
//           <div className="team-info">
//             <h4>{t.team}</h4>
//             <p>{t.replies}</p>
//           </div>
//         </div>

//         {/* Support Buttons List */}
//         <div className="support-links-list">
          
//           {/* Telegram Button */}
//           {siteSetting.supportTelegram && (
//             <a href={siteSetting.supportTelegram} className="support-action-card blue-theme" target="_blank" rel="noreferrer">
//               <div className="action-icon-box">
//                 <img src="/tel.png" alt="Telegram" />
//               </div>
//               <div className="action-text">
//                 <h4>{t.telegram}</h4>
//                 <span>{t.official}</span>
//               </div>
//               <BsArrowRightShort className="arrow-icon" />
//             </a>
//           )}

//           {/* WhatsApp / Contact Button */}
//           {siteSetting.whatsappSupport && (
//             <a href={siteSetting.whatsappSupport} className="support-action-card blue-theme" target="_blank" rel="noreferrer">
//               <div className="action-icon-box">
//                 <img src="/whatsapp.png" alt="Contact" />
//               </div>
//               <div className="action-text">
//                 <h4>{t.contact}</h4>
//                 <span>{t.voice}</span>
//               </div>
//               <BsArrowRightShort className="arrow-icon" />
//             </a>
//           )}

//         </div>

//         {/* Footer Text */}
//         <div className="support-footer-tag">
//           {t.secure}
//         </div>

//       </div>

//       <div className="rightContainer hidden-mobile">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;

import React, { useContext } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";
import { BsWhatsapp, BsTelephoneFill } from "react-icons/bs";
// import "../css/supportNew.css"; // Separate Modern CSS file

const Support = () => {
  const { language } = useContext(LanguageContext);
  const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

  const translations = {
    hi: {
      heading: 'Contact Us At Below Platforms.',
      whatsapp: 'WhatsApp',
      address: 'Address:agra'
    },
    en: {
      heading: 'Contact Us At Below Platforms.',
      whatsapp: 'WhatsApp',
      address: 'Address:agra'
    },
  };

  const t = translations[language] || translations.en;
  const phoneNumber = siteSetting.supportPhone || "8233129181";

  return (
      <div className="leftContainer position-relative mb_space" >
    <div className="support-page-wrapper mt-5 pt-5">
      {/* Main Content Area */}
      <div className="support-content-container">
        
        {/* Heading */}
        <h3 className="support-heading-title">{t.heading}</h3>

        {/* Action Cards Container */}
        <div className="support-cards-row">
          
          {/* WhatsApp Card */}
          <a 
            href={siteSetting.whatsappSupport || "https://wa.me/"} 
            className="support-action-card" 
            target="_blank" 
            rel="noreferrer"
          >
            <div className="support-card-icon-wrap whatsapp-green">
              <BsWhatsapp />
            </div>
            <span className="support-card-label">{t.whatsapp}</span>
          </a>

          {/* Phone / Support Number Card */}
          <a 
            href={`tel:${phoneNumber}`} 
            className="support-action-card"
          >
            <div className="support-card-icon-wrap phone-blue">
              <BsTelephoneFill />
            </div>
            <span className="support-card-label">{phoneNumber}</span>
          </a>

        </div>

        {/* Address Section */}
        <div className="support-address-text mt-4">
          <strong>Address:</strong>agra
        </div>

      </div>

      {/* Right Sidebar Container */}
      <div className="support-sidebar-container mobile-hide">
        <Rightcontainer />
      </div>
    </div></div>
  );
};

Support.defaultProps = {
  siteSetting: {}
};

export default Support;